<template>
  <div id="WatchList">
    <div class="list_slide_box">
      <div>
        <div class="watch_box_list" v-for="(item,index) in list" :key="index">
          <div class="watch_box_flex">
            <div class="watch_box">
              <router-link :to="{path:'/carddetails/'+item.ID}">
                <div class="like_box">
                  <el-image class="like_img" :src="item.TitImg!='没有可上传的图片'?item.TitImg+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain"></el-image>
                  <span v-if="type=='bids'&&item.IsOutBid==2&&item.Status==1" class="favorite">{{$t('base.outBid')}}</span>
                  <span v-if="item.Status==0&&type=='offers'" class="favorite greed">{{$t('base.offerSent')}}</span>
                  <span v-if="item.Status==2&&type=='offers'" class="favorite">{{$t('base.offerReceived')}}</span>
                  <span v-if="item.Status==3&&type=='offers'" class="favorite gray">{{$t('base.offerDeclined')}}</span>
                  <span v-if="item.Status==4&&type=='offers'" class="favorite gray">{{$t('base.offerExpired')}}</span>
                  <span v-if="item.Status==3&&item.AuctionCount==3&&type=='offers'" class="favorite black">{{$t('base.offerClosed')}}</span>
                </div>
              </router-link>
            </div>
            <div class="watch_title_box">
              <div class="watching_height">
                <h4 class="line_txt3">
                  <router-link :to="{path:'/carddetails/'+item.ID}" :class="{'global':item.SellMemberSource!=userInfo.MemberSource}">{{item.Title}}</router-link>
                </h4>
                <span v-if="item.CommodityCode!=null">( {{item.CommodityCode}} )</span>
              </div>
              <div class="watching_height2">
                <!-- <div class="bids">{{item.SellRealName}}( {{item.BuyFavorableCount}} )</div> -->
                <router-link class="bids" :to="{path:'/seller/detail/'+(type=='bids'?item.SellId:item.SellUserID)}">{{item.SellRealName}}( {{item.BuyFavorableCount+item.SellFavorableCount}} )</router-link>
                <!-- <router-link class="bids" :to="{path:'/seller/detail/'+(type=='bids'?item.SellId:item.SellUserID)}">{{item.SellRealName}}( {{item.BuyFavorableCount}} )</router-link> -->
                <div>{{item|setFeedback}} {{$t('base.positive')}}</div>
              </div>
              <div class="watching_height3" v-if="type=='bids'">
                <span>{{$t('colon.maxBid')}} {{areaSymbol}} {{item.USD_MyHighestPrice}}</span>
              </div>
            </div>
            <div class="">
              <div class="watching_height watch_bids" v-if="type=='bids'">
                <div class="price_us" :class="item.IsOutBid==2?'text_red':'text_greed'">{{areaSymbol}} {{item.USD_Price}}</div>
                <!-- <div class="price_us" :class="item.IsOutBid==2?'text_red':'text_greed'" v-if="item.Status!=1">{{areaSymbol}} {{item.USD_Price}}</div> -->
                <router-link class="bids" :to="{path:'/mycardhobby/bidhistory/'+item.ID}">{{item.AuctionCount}} {{item.AuctionCount != 1?$t('base.bids'):$t('base.bid')}}</router-link>
              </div>
              <div class="watching_height watch_bids" v-if="type=='offers'">
                <div class="price_us text_blue" v-if="item.Status==2||(item.Status==1&&(item.USD_SellPrice>0&&(item.USD_SellPrice>item.USD_BuyPrice)))">{{areaSymbol}} {{item.USD_SellPrice}}</div>
                <span v-if="item.Status==2||(item.Status==1&&(item.USD_SellPrice>0&&(item.USD_SellPrice>item.USD_BuyPrice)))">{{$t('base.sellerOffer')}}</span>
                <div class="price_us status" :class="item.Status==2?'no_us':''">{{areaSymbol}} {{item.USD_BuyPrice}}</div>
                <span>{{$t('base.yourOffer')}}</span>
                <div class="price_us no_us">{{areaSymbol}} {{item.Status!=1?item.USD_Price:item.USD_OldPrice}}</div>
                <span>{{$t('base.originalPrice')}}</span>
              </div>
              <div class="watching_height2" v-if="type=='bids'">
                <div :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''" v-if="item.EffectiveTime!='Ended listing'">{{ CountDown(item.EffectiveDate) }}</div>
                <div class="time_end">{{item.EffectiveDate|setTime}}</div>
              </div>
              
              <div class="watching_height2" v-if="type=='offers'&&item.Status!=1">
                <div class="time_end">{{$t('base.offerExpires')}}</div>
                <div :class="CountDown(item.FailureTime)=='00:00'&&(getCountDown(item.FailureTime)!=1||item.Status==1)?'':'text_red'">{{ CountDown(item.FailureTime) }}</div>
                <div class="time_end">{{item.FailureTime|setTime}}</div>
              </div>
              <div class="watching_height2" style="width: 120px;" v-if="type=='offers'&&item.Status==1">
              </div>
            </div>
            <div class="watch_box_btn">
              <div @click='getAuctionCheck(item)' v-if="userInfo.Count>0&&item.IsOutBid==2&&item.Status==1">{{$t('base.increaseMaxBid')}}2</div>
              <div @click="isAddCout" v-if="userInfo.Count<=0&&item.IsOutBid==2">{{$t('base.increaseMaxBid')}}1</div>
              <!-- <div>
                <router-link :to="{path:'/market'}">View Similar Items</router-link>
              </div> -->
              <!-- <div v-if="type=='offers'&&item.Status==1&&userInfo.Count>0">Pay Now</div> -->
              <div v-if="type=='offers'&&item.Status!=4&&item.Status!=1&&userInfo.Count>0" @click="BuyItNow(item)">{{item.Status==2?$t('base.acceptNewOffer'):$t('base.buyNow')}}</div>
              <div v-if="type=='offers'&&item.Status!=4&&item.Status!=1&&userInfo.Count<=0" @click="isAddCout">{{item.Status==2?$t('base.acceptNewOffer'):$t('base.buyNow')}}</div>
              <div v-if="type=='offers'&&(item.NewStatus!=0&&item.Status!=1&&item.Status!=4&&item.FrequencyCount<3)&&userInfo.Count>0" @click="getMakeOffer(item)">{{item.Status==2?$t('base.offerAgain'):$t('base.increaseOffer')}}</div>
              <div v-if="type=='offers'&&(item.NewStatus!=0&&item.Status!=1&&item.Status!=4&&item.FrequencyCount<3)&&userInfo.Count<=0" @click="isAddCout">{{item.Status==2?$t('base.offerAgainOffer'):$t('base.increaseOffer')}}</div>
              <div>
                <router-link v-if="type=='bids'" :to="{path:'/seller/detail/'+item.SellId}">{{$t('base.visitStore')}}</router-link>
                <router-link v-if="type=='offers'" :to="{path:'/seller/detail/'+item.SellUserID}">{{$t('base.visitStore')}}</router-link>
              </div>
              <div class="ContactSeller" @click="allContact((type=='bids'?item.SellId:item.SellUserID),item.ID)">{{$t('base.contactSeller')}}</div>
              <!-- <div>
                <router-link :to="{path:'/terms/customer',query:{item:JSON.stringify(item),seller:item.SellRealName,sellerid:item.SellId}}">Contact Seller</router-link>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- el-dialog -->
    <place-bid v-if="PlaceList!=null&&type=='bids'" :Visible="placeVisible" @getDialog="getPlace" :placeList="PlaceList" :Auction='isAuction' :time="EffectiveDate" />
    <make-offer v-if="type=='offers'" :makeVisible="makeVisible" @getDialog="getDialog" :list="PlaceList" />
  </div>
</template>
<script>
import MakeOffer from "@/components/dialog/makeoffer";
import PlaceBid from "@/components/dialog/placebid";
import { countDown, setUTC, getTime, getInfo, GoYunXin } from "@/api/public";
import qs from 'qs'
export default {
  name: 'watchlist',
  components: { MakeOffer, PlaceBid },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      PlaceList: null,
      isAuction: false,
      placeVisible: false,
      makeVisible: false,
      userInfo: null,
      timer: "",
      nowData: new Date().getTime(),
      checkAll: false,
      checkedCities: [],
      cities: this.list,
      isIndeterminate: false
    }
  },
  props: {
    list: {},
    type: String
  },

  filters: {
    day(val) {
      if (val.indexOf('00:00') != -1) {
        return 'text_red'
      } else if (val.indexOf('D') != -1) {
        var num = val.indexOf('D')
        if (num <= 1) {
          return 'text_greed'
        }
        return 'text_red'
      }
    },
    setFeedback(val) {
      var FavorableCount=(val.BuyFavorableCount+val.SellFavorableCount)
      var TotalCount=(val.BuyFavorableCount + val.SellFavorableCount + val.BuyNegativeCount+val.SellNegativeCount)
      let data = ((FavorableCount / TotalCount) * 100)
      if (TotalCount > 0) {
        if (data != 100) {
          data = data.toFixed(2)
        }
      } else {
        data = 100
      }
      return data + '%'
    },
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    }
  },
  created() {
    this.userInfo = getInfo()
    this.cardTimer();
  },
  methods: {
    allContact(val,oid) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val,oid,1000)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    getMakeOffer(val) {
      let that = this
      //console.log(val)
      that.PlaceList = val;
      that.makeVisible = true;
    },
    BuyItNow(val) {
      let that=this
      
      if (val.Status != 2) {
        let data = {
          "HeadPortrait": "https://bucket-katao.oss-cn-hangzhou.aliyuncs.com/touxiang.png",
          "SellRealName": val.SellRealName,
          "BuyerWyAccId": this.userInfo.MappingUserId,
          "SellerWyAccId": val.SellUserID,
          "Details": [{
            "ID": val.ID,
            "Title": val.Title,
            "TitImg": val.TitImg,
            "USD_Price": val.Status == 2 ? val.USD_SellPrice : val.USD_Price,
          }],
          "USD_PostageMoney": '0',
          "USD_TotalPrice": val.Status == 2 ? val.USD_SellPrice : val.USD_Price
        }
        window.sessionStorage.setItem('check', JSON.stringify(data))
        this.$router.push({
          path: '/pay/checkout/'
        })
      } else {
        that.$confirm('<div style="text-align: center;">You will accept new offer from seller: '+that.areaSymbol+val.USD_SellPrice+'</div>', 'Accept New Offer', {
          confirmButtonText: 'Comfirm',
          cancelButtonText: 'Cancel',
          lockScroll:false,
          dangerouslyUseHTMLString: true
        }).then(() => {
          that.setBargainList(val)
        }).catch(() => {
                   
        });
      }
    },
    //出价历史/商品议价信息
    setBargainList(val){
      let that=this
      let data={memberid:that.userInfo.MappingUserId,operator_id:that.userInfo.MappingUserId,token:that.userInfo.ChineseToken,CommodityID:val.ID}
      that.$get(that.$interface.BargainList, data).then(res => {
        if (res.result != 0) {
          let result = res.data[0]
          that.setApprove(result);
        }else{

        }
      })
    },
    // 同意议价
    setApprove(item) {
      let that = this
      let data = { id: item.ID, ApproveType: 1, operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }
      that.$post(that.$interface.Approve, qs.stringify(data)).then(res => {
        if (res.result != 0) {
          this.$router.push({
            path: '/mycardhobby/purchase?type=1'
          })
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      })
    },
    isAddCout() {
      this.$confirm('You have not set your shipping address!', 'Something Important', {
        confirmButtonText: 'Go to Set',
        cancelButtonText: 'Cancel',
        lockScroll: false
      }).then(() => {
        let url = this.$router.resolve({ path: '/mycardhoddy/setting' })
        window.open(url.href, '_blank');
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });          
      });
    },
    //竞拍资格校验
    getAuctionCheck(val) {
      let that = this
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': val.ID }
      val.USD_HighestPrice=val.USD_MyHighestPrice
      that.PlaceList = val;
      //console.log(val,that.PlaceList,'that.PlaceList')
      that.EffectiveDate = val.EffectiveDate
      this.$get(this.$interface.AuctionCheck, data).then(res => {
        //that.isread=false;
        if (res.result == 1) {
          that.isAuction = true;
          that.placeVisible = true;
        } else {
          that.PlaceList.DepositNum = res.data.DepositNum;
          that.PlaceList.SumMoney = res.data.SumMoney;
          that.isAuction = false;
          that.placeVisible = true;
        }
        //this.getPrice()
        // msg: '竞拍校验通过', result: 1
      })
    },
    getPlace(val, val1) {
      this.placeVisible = val;
      this.PlaceList = null;
      this.EffectiveDate = '';
      this.isAuction = false;
      if (val1) {
        this.$emit('updatedWatch');
      }
    },
    getDialog(val) {
      this.makeVisible = val
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    getCountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval, 0)
    },
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8,'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval)
    },
    handleCheckAllChange(val) {
      //console.log(val,this.list)
      this.checkedCities = val ? this.list : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      //console.log(value)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      //console.log(this.isIndeterminate)
    },
    WatchDelete() {
      //console.log(this.checkedCities)
    }
  },
  //离开页面后清除定时器
  destroyed() {
    clearInterval(this.timer);
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/watchlist.css";

.el-checkbox {
  color: #333;
}

.watch_checkbox,
.watch_box_flex {
  width: 100%;
}

.el-checkbox__label {
  padding-left: 24px;
  width: 96%;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #333;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-checkbox__input.is-focus .el-checkbox__inner {
  background-color: #fff;
  border-color: #333;
}

.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  background-color: #333;
}

.el-checkbox__inner::after,
.el-checkbox__inner:hover,
.el-checkbox__input.is-disabled .el-checkbox__inner::after,
.el-checkbox__inner {
  border-color: #333
}

.watch_checkbox .el-checkbox__input {
  margin-top: -30%;
}

.watch_checkbox_all .el-checkbox__input {
  margin-top: 7px;
}

.watch_checkbox_box {
  display: flex;
  padding: 22px 0;
  border-bottom: 1px solid #f0f0f0;
}

.watch_box_flex {
  display: flex;
  white-space: normal;
  justify-content: space-between;
}

.watch_delete {
  font-size: 14px;
  border: 1px solid #333;
  font-weight: bold;
  border-radius: 4px;
  height: 32px;
  width: 80px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  margin-left: 22px;
}

.time_end span {
  display: block;
}

.ContactSeller {
  cursor: pointer;
}

.watching_height {
  height: 142px;
}
.global{
}
.global:before{
  float: left;
  content: '';
  background: url(/static/images/icon/icon_earth.svg) no-repeat 0 50%;
  width: 16px;
  height: 24px;
  margin-right: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/list/watch.vue